import { useState } from 'react';
import { getDefaultOptions, getOptionsForBinary } from '../utils/api';

export const useDefaultOptions = (language: string, refetchInterval: false | number = false) => {
  const [defaultOptions] = useState(getDefaultOptions(language, refetchInterval));
  return defaultOptions;
};

export const useOptionsForBinary = (language: string) => {
  const [options] = useState(getOptionsForBinary(language));
  return options;
};
